import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AdminRoute from './components/AdminRoute'
import Header from './components/Header'
import SearchForm from './components/SearchForm'
import CertificateViewer from './components/CertificateViewer'
import LoginForm from './components/LoginForm'
import AdminDashboard from './components/AdminDashboard'
import './App.css'

function App() {
  return (
    <div className="min-h-screen bg-gray-50 font-inter">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/certificate/:lotNumber" element={<CertificateViewer />} />
          <Route path="/login" element={<LoginForm />} />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
        </Routes>
      </main>
    </div>
  )
}

const HomePage = () => {
  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-8">
            <img
              src="https://moringapowder.com/cdn/shop/files/Pura_Vida_logo.png?v=1614806534&width=240"
              alt="Pura Vida Moringa"
              className="h-16 w-auto object-contain"
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4 font-inter">
            Certificate of Analysis Lookup
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Access your product's Certificate of Analysis (COA) to verify quality,
            safety, and testing results for complete transparency and peace of mind.
          </p>
        </div>

        <SearchForm />
      </div>
    </div>
  )
}

export default App
